<template>
  <div>

    <q-list v-if="fieldValue && fieldValue.employments && fieldValue.employments.length > 1" bordered padding class="rounded-borders q-mb-md">
      <template v-for="(place, place_index) in fieldValue.employments"
                :key="place_index">
      <q-item clickable v-ripple  v-if="fieldValue.employments[place_index].valid" active-class="bg-teal-1 text-grey-8" :active="place_index === index">
        <q-item-section avatar top>
          <q-avatar icon="s_place" color="grey" text-color="white" />
        </q-item-section>

        <q-item-section @click="selectEmployment(place_index)">
          <q-item-label lines="1">{{fieldValue.employments[place_index].employer}} {{fieldValue.employments[place_index].job_title}},  {{fieldValue.employments[place_index].type}}</q-item-label>
          <q-item-label caption><span v-if="fieldValue.employments[place_index].address">{{fieldValue.employments[place_index].address}}</span>
            <span v-if="fieldValue.employments[place_index].unit"> {{fieldValue.employments[place_index].unit}},</span>
            <span v-if="fieldValue.employments[place_index].city"> {{fieldValue.employments[place_index].city}},</span>
            <span v-if="fieldValue.employments[place_index].state"> {{fieldValue.employments[place_index].state}},</span>
            <span v-if="fieldValue.employments[place_index].zip"> {{fieldValue.employments[place_index].zip}}</span>
            </q-item-label>
        </q-item-section>

        <q-item-section side @click.stop="confirmDeleteAlert(place_index)">
          <q-icon name="s_delete" color="amber"  />
        </q-item-section>
      </q-item>
      </template>
    </q-list>
    <div class="text-subtitle1 q-py-sm ">Add Current or Previous Job</div>
    <template v-if="index !== null && fieldValue.employments[index] !== undefined">
      <q-form
          @submit="onSubmit"
          ref="form"
      >
      <div class="full-width">
        <div class="row  ">
          <div class="col-md-12">
      <q-field
          borderless
          v-model="fieldValue.employments[index].type"
          :rules="[ val => val && val.length > 0 || 'Please select employment type']"
          :hide-bottom-space="true"
      >
        <template v-slot:control>
          <q-option-group
              :options="this.types"
              type="radio"
              v-model="fieldValue.employments[index].type"
              debounce="500"
          />
        </template>
      </q-field>
          </div>
        </div>
        <div class="row  ">
          <div class="col-12 col-md-8 q-px-sm q-py-sm ">
            <FieldText
                v-model="fieldValue.employments[index].employer"
                :field="{layout_injected_label: 'Employer name', label: 'Employer', required: true, requiredText: null, options: {}}"
                :hide_bottom_space="true"
                :rules="[ val => val && val.length > 0 || 'Please enter employer name']"
            ></FieldText>
          </div>
          <div class="col-12 col-md-4 q-px-sm q-py-sm ">
            <FieldText
                v-model="fieldValue.employments[index].job_title"
                :field="{layout_injected_label: 'Job title', label: 'Job title', required: true, requiredText: null, options: {}}"
                :hide_bottom_space="true"
                :rules="[ val => val && val.length > 0 || 'Please enter job title']"
            ></FieldText>
          </div>
        </div>
        <div class="text-subtitle1 q-py-sm  ">Employer Location</div>
      <div class="row ">
        <div class="col-12 col-md-8 q-px-sm q-py-sm ">
          <FieldAddress
              v-model="fieldValue.employments[index].address"
              :field="{layout_injected_label: 'Address', label: 'Address', required: true, requiredText: null, options: {}}"
              @onAddressSelected="onAddressSelected"
              :doNotCheckStateLicense="true"
              :hide_bottom_space="true"
              :rules="[ val => val && val.length > 0 || 'Please enter address']"
          ></FieldAddress>
        </div>
        <div class="col-12 col-md-4 q-px-sm q-py-sm ">
          <FieldText
              v-model="fieldValue.employments[index].unit"
              :field="{layout_injected_label: 'Unit', label: 'Unit', required: false, requiredText: null, options: {}}"
              :hide_bottom_space="true"
          ></FieldText>
        </div>
      </div>
        <div class="row ">
          <div class="col-12 col-md-4 q-px-sm q-py-sm ">
            <FieldText
                v-model="fieldValue.employments[index].city"
                :field="{layout_injected_label: 'City', label: 'City', required: true, requiredText: null, options: {}}"
                :rules="[ val => val && val.length > 0 || 'Please enter city']"
            ></FieldText>
          </div>
          <div class="col-12 col-md-4 q-px-sm q-py-sm ">
            <FieldState
                v-model="fieldValue.employments[index].state"
                :field="{layout_injected_label: 'State', label: 'State', required: true, requiredText: null, options: {}}"
                :rules="[ val => val && val.length > 0 || 'Please select state']"
            ></FieldState>
          </div>
          <div class="col-12 col-md-4 q-px-sm q-py-sm ">
            <FieldZipcode
                v-model="fieldValue.employments[index].zip"
                :field="{layout_injected_label: 'Zip', label: 'Zip', required: true, requiredText: null, options: {}}"
                :rules="[ val => val && val.length > 0 || 'Please enter zipcode']"
            ></FieldZipcode>
          </div>
        </div>
        <div class="row  ">
          <div class="col-12 col-md-4 q-px-sm q-py-sm ">
<!--            <FieldSelect-->
<!--                v-model="fieldValue.employments[index].years"-->
<!--                :field="{layout_injected_label: 'Years In This Line of Work', label: 'Years In This Line of Work', required: true, requiredText: null,-->
<!--                options: {-->
<!--                  0: 'Less than a year',-->
<!--                  1: '1 Years',-->
<!--                  2: '2 Years',-->
<!--                  3: '3 Years',-->
<!--                  4: '4 Years',-->
<!--                  5: '5 Years',-->
<!--                  6: '6 Years',-->
<!--                  7: '7 Years',-->
<!--                  8: '8 Years',-->
<!--                  9: '9 Years',-->
<!--                  10: '10 Years'-->
<!--                }-->
<!--                }"-->
<!--                :hide_bottom_space="true"-->
<!--            ></FieldSelect>-->
            <FieldNumber
                v-model="fieldValue.employments[index].years"
                :field="{layout_injected_label: 'Years In This Line of Work', label: 'Years In This Line of Work', required: true, requiredText: null,
                }"
                :hide_bottom_space="true"
            ></FieldNumber>
          </div>
          <div class="col-12 col-md-4 q-px-sm q-py-sm ">
            <FieldDate
                v-model="fieldValue.employments[index].start_date"
                :field="{layout_injected_label: 'Start date', label: 'Start date', required: true, requiredText: null, options: {}}"
                :hide_bottom_space="true"
                :rules="[ val => val && val.length > 0 || 'Please enter Start date']"
            ></FieldDate>
          </div>
          <div class="col-12 col-md-4 q-px-sm q-py-sm " v-if="fieldValue.employments[index].type === 'Previous'">
            <FieldDate
                
                v-model="fieldValue.employments[index].end_date"
                :field="{layout_injected_label: 'End date', label: 'End date', required: true, requiredText: null, options: {}}"
                :hide_bottom_space="true"
                :rules="[ val => val && val.length > 0 || 'Please enter end date']"
            ></FieldDate>
          </div>
        </div>
        <div class="row ">
          <div class="col-12 col-md-8 q-px-sm q-py-sm ">
            <FieldPhone
                v-model="fieldValue.employments[index].phone"
                :field="{layout_injected_label: 'Phone', label: 'Phone', required: false, requiredText: null, options: {}}"
            ></FieldPhone>
          </div>
          <div class="col-12 col-md-4 q-px-sm q-py-sm ">
            <FieldMoney
                v-if="fieldValue.employments[index].type === 'Previous'"
                v-model="fieldValue.employments[index].previous_income"
                :field="{layout_injected_label: 'Gross Monthly Income', label: 'Gross Monthly Income', required: true, requiredText: 'Please enter Monthly Income', options: {}}"
            ></FieldMoney>
          </div>
        </div>
        <div class="text-subtitle1 q-py-sm  " v-if="fieldValue.employments[index].type === 'Current'">Income</div>
        <div class="row  " v-if="fieldValue.employments[index].type === 'Current'">
          <div class="col-12 col-md-4 q-px-sm q-py-sm ">
            <FieldMoney
                v-model="fieldValue.employments[index].current_income"
                :field="{layout_injected_label: 'Monthly Base Pay', label: 'Monthly Base Pay', required: true, requiredText: null, options: {}}"
            ></FieldMoney>
          </div>
          <div class="col-12 col-md-4 q-px-sm q-py-sm ">
            <FieldMoney
                v-model="fieldValue.employments[index].current_overtime"
                :field="{layout_injected_label: 'Overtime', label: 'Overtime', required: false, requiredText: null, options: {}}"
            ></FieldMoney>
          </div>
          <div class="col-12 col-md-4 q-px-sm q-py-sm ">
            <FieldMoney
                v-model="fieldValue.employments[index].current_bonuses"
                :field="{layout_injected_label: 'Bonuses', label: 'Bonuses', required: false, requiredText: null, options: {}}"
            ></FieldMoney>
          </div>
        </div>
        <div class="row " v-if="fieldValue.employments[index].type === 'Current'">
          <div class="col-12 col-md-4 q-px-sm q-py-sm ">
            <FieldMoney
                v-model="fieldValue.employments[index].current_commission"
                :field="{layout_injected_label: 'Commission', label: 'Commission', required: false, requiredText: null, options: {}}"
            ></FieldMoney>
          </div>
          <div class="col-12 col-md-4 q-px-sm q-py-sm ">
            <FieldMoney
                v-model="fieldValue.employments[index].current_military_entitlements"
                :field="{layout_injected_label: 'Military Entitlements', label: 'Military Entitlements', required: false, requiredText: null, options: {}}"
            ></FieldMoney>
          </div>
          <div class="col-12 col-md-4 q-px-sm q-py-sm ">
            <FieldMoney
                v-model="fieldValue.employments[index].current_other"
                :field="{layout_injected_label: 'Other', label: 'Other', required: false, requiredText: null, options: {}}"
            ></FieldMoney>
          </div>
        </div>


        <div class="row ">
          <div class="col-12 col-md-6 q-px-sm q-py-sm ">
            <q-checkbox v-model="fieldValue.employments[index].business_owner_or_self_employment" label="Check if you are the Business Owner or Self-Employed" />
            <q-field
                v-if="fieldValue.employments[index].business_owner_or_self_employment"
                borderless
                v-model="fieldValue.employments[index].business_owner_share_size"
                :rules="[ val => val && val.length > 0 || 'Please select ownership share size']"
                :hide-bottom-space="true"
            >
              <template v-slot:control>
                <q-option-group
                    :options="this.share_sizes"
                    type="radio"
                    v-model="fieldValue.employments[index].business_owner_share_size"
                    debounce="500"
                />
              </template>
            </q-field>
            <FieldMoney
                v-if="fieldValue.employments[index].business_owner_or_self_employment"
                v-model="fieldValue.employments[index].business_owner_income_or_loss"
                :field="{layout_injected_label: 'Monthly Income (or Loss)', label: 'Monthly Income (or Loss)', required: false, requiredText: null, options: {}}"
            ></FieldMoney>
          </div>
          <div class="col-12 col-md-6 q-px-sm q-py-sm ">
            <q-checkbox v-model="fieldValue.employments[index].transaction_related_employment" label="I am employed by a family member, property seller, real estate agent, or other party to the transaction" />
          </div>
        </div>


        <div class="row  ">
          <div class="col-12 q-py-sm q-ml-none col-md-12 q-gutter-sm q-gutter-y-md">


            <q-btn
                v-if="fieldValue.employments.length > 1"
                class="mw-form-v2-btn-submit "
                :flat="!settings.theme.next.cs ? settings.theme.button.flat: null"
                :rounded="!settings.theme.next.cs ? settings.theme.button.rounded: null"
                :round="!settings.theme.next.cs ? settings.theme.button.round: null"

                :outline="true"
                :push="!settings.theme.next.cs ? settings.theme.button.push: null"
                :unelevated="!settings.theme.next.cs ? settings.theme.button.unelevated: true"
                :noCaps="!settings.theme.next.cs ? settings.theme.button.noCaps: null"
                :glossy="!settings.theme.next.cs ? settings.theme.button.glossy : null"
                :size="settings.theme.next.cs ? settings.theme.next.size : settings.theme.button.size"

                label="Remove this Employment" type="button" color="primary"
                :class="{'mw-form-v2-btn-next-cs':  settings.theme.next.cs}"
                @click="confirmDeleteAlert(index)"
            >
            </q-btn>

            <q-btn

                class="mw-form-v2-btn-submit "
                :flat="!settings.theme.next.cs ? settings.theme.button.flat: null"
                :rounded="!settings.theme.next.cs ? settings.theme.button.rounded: null"
                :round="!settings.theme.next.cs ? settings.theme.button.round: null"

                :outline="true"
                :push="!settings.theme.next.cs ? settings.theme.button.push: null"
                :unelevated="!settings.theme.next.cs ? settings.theme.button.unelevated: true"
                :noCaps="!settings.theme.next.cs ? settings.theme.button.noCaps: null"
                :glossy="!settings.theme.next.cs ? settings.theme.button.glossy : null"
                :size="settings.theme.next.cs ? settings.theme.next.size : settings.theme.button.size"

                label="Add Another Employment" type="submit" color="primary"
                :class="{'mw-form-v2-btn-next-cs':  settings.theme.next.cs}"
            >
            </q-btn>

            <q-btn

                class="mw-form-v2-btn-submit "
                :flat="!settings.theme.next.cs ? settings.theme.button.flat: null"
                :rounded="!settings.theme.next.cs ? settings.theme.button.rounded: null"
                :round="!settings.theme.next.cs ? settings.theme.button.round: null"
                color="black"
                :outline="true"
                :push="!settings.theme.next.cs ? settings.theme.button.push: null"
                :unelevated="!settings.theme.next.cs ? settings.theme.button.unelevated: true"
                :noCaps="!settings.theme.next.cs ? settings.theme.button.noCaps: null"
                :glossy="!settings.theme.next.cs ? settings.theme.button.glossy : null"
                :size="settings.theme.next.cs ? settings.theme.next.size : settings.theme.button.size"

                label="I have no source of income" type="button" 
                :class="{'mw-form-v2-btn-next-cs':  settings.theme.next.cs}"
                @click="noSourceOfIncome()"
            >
            </q-btn>


          </div>
        </div>
      </div>
      </q-form>
    </template>

    <q-field class="field_no_bottom_line" :hide-bottom-space="true"   :rules="[val => isValid() || 'Must Enter at least one employment']">
    </q-field>

    <q-field v-if="field.options && field.options.two_year" class="field_no_bottom_line" :hide-bottom-space="true"   :rules="[val => has2Years() || 'Must Enter at least 2 years of employment']">

    </q-field>

    <q-dialog v-model="confirm" persistent>
      <q-card>
        <q-card-section class="row   items-center">
          <q-avatar icon="s_place" color="primary" text-color="white" />
          <span class="q-ml-sm">Switch to this address will clear a current item.</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn flat label="Confirm" @click="clearCurrentAndSwitch()" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="confirmDelete" persistent>
      <q-card>
        <q-card-section class="row   items-center">
          <q-avatar icon="s_place" color="primary" text-color="white" />
          <span class="q-ml-sm">Are you sure to delete this address {{fieldValue.employments[confirmDeleteIndex] && fieldValue.employments[confirmDeleteIndex].address}}?</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn flat label="Delete" @click="deleteItem()" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import FieldAddress from "@/components/fields/FieldAddress";
import FieldText from "@/components/fields/FieldText";
import FieldState from "@/components/fields/FieldState";
import FieldZipcode from "@/components/fields/FieldZipcode";
// import FieldSelect from "@/components/fields/FieldSelect";
import FieldDate from "@/components/fields/FieldDate";
import FieldMoney from "@/components/fields/FieldMoney";
import FieldPhone from "@/components/fields/FieldPhone";
import {mapActions} from "vuex";
import FieldNumber from "@/components/fields/FieldNumber";
export default {
  components: {
    FieldNumber,
    FieldAddress,
    FieldText,
    FieldState,
    FieldZipcode,
    // FieldSelect,
    FieldDate,
    FieldMoney,
    FieldPhone
  },
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {
        confirm: false,
        confirmIndex: null,
        confirmIndexToClear: null,
        confirmDelete: false,
        confirmDeleteIndex: null,
        types:[
          { label: 'This is my current employment', value: 'Current' },
          { label: 'This is a previous employment', value: 'Previous'}
        ],
        share_sizes:[
          { label: 'I have an ownership share of 25% or more', value: 'more then 25%' },
          { label: 'I have an ownership share of less than 25%', value: 'less then 25%'}
        ],
        employment: {
          type: "",
          employer: "",
          job_title: "",
          phone: "",
          address: "",
          unit: "",
          city: "",
          state: "",
          zip: "",
          country: "",
          years: "",
          start_date: "",
          end_date: "",
          business_owner_or_self_employment: false,
          business_owner_share_size: "",
          business_owner_income_or_loss: "",
          transaction_related_employment: false,
          // current values
          current_income: "",
          current_overtime: "",
          current_bonuses: "",
          current_commission: "",
          current_military_entitlements: "", //Military Entitlements
          current_other: "",
          // previous values
          previous_income: "",
        },
        employments:[

        ],
        index: null
    };
  },
  emits: ['update:modelValue'],
  methods: {
    ...mapActions({
      nextScreen: 'values/list/nextScreen'
    }),
    noSourceOfIncome() {
      this.fieldValue.no_source_of_income = true;
      //this.fieldValue.employments = [];
      this.nextScreen({form : this.form});
    },
    isValidEmployment(index) {
      const employment = this.fieldValue.employments[index];
      return !(
          !employment.employer
          || !employment.type
          || !employment.job_title
          || !employment.address
          || !employment.city
          || !employment.zip
          || !employment.years
          || !employment.start_date
          || (!employment.end_date && employment.type === "Previous")
          || ((employment.previous_income === null || employment.previous_income === 0 || employment.previous_income === '0') && employment.type === "Previous")
      );

    },
    isValid () {
      this.$refs.form.validate().then((success) => {
        this.fieldValue.employments[this.index].valid = success;
      });
      return this.isValidEmployment(this.index);
    },
    has2Years () {
      if(!this.field.options.two_year) {
        return true;
      }
      this.$refs.form.validate().then((success) => {
        this.fieldValue.employments[this.index].valid = success;
      });
      let years = 0;
      this.fieldValue.employments.forEach((employment) => {
        const start_date = new Date(employment.start_date);
        if((start_date  instanceof Date)){
          let diffYears = 0;
          var currentdate = new Date();
          if(employment.type === 'Current') {
            const diffTime = Math.abs(currentdate - start_date);
            diffYears = diffTime / (1000 * 60 * 60 * 24 * 365);
          } else  {
            const end_date = new Date(employment.end_date);
            if(end_date instanceof Date) {
              const diffTime = Math.abs(end_date - start_date);
              diffYears = diffTime / (1000 * 60 * 60 * 24 * 365);
            }
          }
          years= years + diffYears;
        }
      });
      return years >= 2;
    },
    onSubmit() {
      this.fieldValue.employments[this.index].valid = true;
      this.index = this.fieldValue.employments.push(Object.assign({}, this.employment)) - 1;
      this.$refs.form.reset();
    },
    onAddressSelected(employment) {
      this.fieldValue.employments[this.index].city = employment.city;
      this.fieldValue.employments[this.index].state = employment.state;
      this.fieldValue.employments[this.index].zip = employment.zipcode;
    },
    selectEmployment(place_index) {
      //this.$refs.form.resetValidation();
      this.confirmIndex = place_index;
      this.confirmIndexToClear = this.index;
      this.$refs.form.validate().then(success => {
        if (success) {
          this.index = place_index;
        }
        else {
          this.confirm = true;
        }
      });
    },
    clearCurrentAndSwitch() {
      this.$refs.form.reset();
      this.index = this.confirmIndex;
      this.fieldValue.employments.splice(this.confirmIndexToClear, 1);
    },
    confirmDeleteAlert(index) {
      console.log(this.fieldValue.employments);
      this.confirmDeleteIndex = index;
      this.confirmDelete = true;

    },
    deleteItem() {
      if(this.fieldValue.employments.length === 1) {
        this.fieldValue.employments.push(Object.assign({}, this.employment));
      }
      this.fieldValue.employments.splice(this.confirmDeleteIndex, 1);
      this.index = this.fieldValue.employments.length -1;
    }
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings',
      form: 'form'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {
      if(this.fieldValue === undefined || this.fieldValue === null) {
        this.fieldValue = {
          employments: [
            Object.assign({}, this.employment)
          ]
        };
      }
      this.index = 0;
  }
}
</script>
<style>
.field_no_bottom_line .q-field__control:before {
  border-bottom-color: transparent !IMPORTANT;
}
.field_no_bottom_line  .q-field__control:after {
  background: none !important;
}
.field_no_bottom_line .q-field__control {
  display: none;
}
</style>
